import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.dustyTeal,
  arrowHoverBgColor: colors.stoneTeal,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.charcoalGrey,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.charcoalGrey,
  paginationBorderColor: colors.charcoalGrey,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.dustyTeal,
  heroPaginationInactiveColorVariationC: colors.dustyTeal,
  heroPaginationActiveColor: colors.dustyTeal,
  heroPaginationBorderColor: colors.stoneTeal,
  bgColor: colors.white,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;